import React, { useState, useEffect } from 'react'
import { Alert, Box, TextField, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Select, MenuItem, FormControl, CircularProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBulkFuelDelivery, postBulkFuelDelivery } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { v4 as uuidv4 } from 'uuid';

const BulkFuelDelivery = ({ projectId, project }) => {
    const [bulkFuelDeliveryState, setBulkFuelDeliveryState] = useState([])
    const dispatch = useDispatch()
    const bulkFuelDeliveries = useSelector(state => state.tigercatBurnsReducer.bulkFuelDeliveries.data)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        dispatch(getBulkFuelDelivery(projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        const formDataArray = bulkFuelDeliveries?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('date', item.date);
            formData.append('fuelType', item.fuelType);
            formData.append('fuelVolumeDelivered', item.fuelVolumeDelivered);
            formData.append('sourceDocument', item.sourceDocumentUrl);
            formData.append('disabled', true)
            return formData;
        });
        setBulkFuelDeliveryState(formDataArray);
    }, [bulkFuelDeliveries]);

    const handleAddItem = () => {
        setBulkFuelDeliveryState((prevState) => {
            const state = [...prevState]
            // let id;
            // if (state.length === 0) {
            //     id = null
            // } else {
            //     id = Number(state[state.length - 1].get('id')) + 1
            // }
            const formData = new FormData();
            formData.append('id', null);
            formData.append('date', null);
            formData.append('fuelType', null);
            formData.append('fuelVolumeDelivered', null);
            formData.append('sourceDocument', null);
            formData.append('rowId', uuidv4())
            state.push(formData)
            return state
        })
    }

    const handleDateSelection = (date, dataId) => {
        setBulkFuelDeliveryState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    item.set('date', formattedDate);
                }
                return item;
            });
        });
    }

    const handleFuelTypeChange = (e, dataId) => {
        setBulkFuelDeliveryState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('fuelType', e.target.value);
                }
                return item;
            });
        });
    }

    const handleVolumeDeliveredChange = (e, dataId) => {
        setBulkFuelDeliveryState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('fuelVolumeDelivered', e.target.value);
                }
                return item;
            });
        });
    }

    const handleSourceDoc = (e, dataId) => {
        const file = e.target.files[0];
        setBulkFuelDeliveryState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('sourceDocument', file);
                }
                return item;
            });
        });
    }

    const fuelTypes = [
        { id: 0, name: 'Diesel Red' },
        { id: 1, name: 'Diesel Clear' }
    ]

    const handleSubmitData = () => {
        setLoading(true)
        let hasError = false
        bulkFuelDeliveryState.forEach((i) => {
            if (i.get('date') === 'null' || i.get('fuelType') === 'null' || i.get('fuelVolumeDelivered') === 'null') {
                setError(true)
                hasError = true
                return
            }
        })
        if (!hasError) {
            setError(false)
            dispatch(postBulkFuelDelivery(projectId, bulkFuelDeliveryState)).then(() => {
                dispatch(getBulkFuelDelivery(projectId))
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'bulk_fuel_delivery')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_bulk_fuel_delivery.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Equipment Transport:', err);
        }
    };

    return (
        <>
            <h2>Bulk Fuel Delivery</h2>
            <TableContainer key={0} component={Paper} >
                <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">
                                Date
                            </TableCell>
                            <TableCell size="small" align="left">
                                Fuel Type (ff)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Fuel Volume Delivered (gal)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Source document
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bulkFuelDeliveryState?.map((data, index) => {
                            const sourceDocument = data.get('sourceDocument');
                            const isString = typeof sourceDocument === 'string' && sourceDocument !== 'null';
                            return (

                                <TableRow key={index}>
                                    <TableCell size="small" align="left">
                                        <FormControl>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    slotProps={{
                                                        textField: {
                                                            error: false,
                                                        }
                                                    }}
                                                    name={'date'}
                                                    value={data.get('date') ? moment(data.get('date'), 'YYYYMMDD') : null}
                                                    onChange={(e) => handleDateSelection(e._d, data.get('rowId'))}
                                                    disabled={data.get('disabled') ?? false}
                                                    format="MM/DD/YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <Select name='fuel type' value={data.get('fuelType')} disabled={data.get('disabled') ?? false} fullWidth onChange={(e) => handleFuelTypeChange(e, data.get('rowId'))}>
                                            {fuelTypes?.map(type => {
                                                return (
                                                    <MenuItem key={type.id} value={type.name} >
                                                        {type.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='fuel volume delivered'
                                            value={JSON.parse(data.get('fuelVolumeDelivered')) === null ? '' : data.get('fuelVolumeDelivered')}
                                            onChange={(e) => handleVolumeDeliveredChange(e, data.get('rowId'))}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}

                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {isString ? (
                                            <a href={sourceDocument} target="_blank" rel="noopener noreferrer">
                                                Document
                                            </a>
                                        ) : (
                                            <TextField
                                                name={'Lab results'}
                                                defaultValue={sourceDocument && sourceDocument.name ? sourceDocument.name : ''}
                                                onChange={(e) => handleSourceDoc(e, data.get('rowId'))}
                                                type="file"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {error ? <Alert severity='error' sx={{ my: 2 }}>Please fill out all fields before submitting</Alert> : null}
            <Box sx={{ position: 'relative', mb: 10 }}>
                <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleAddItem}>Add Entry</Button>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress> : <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>Submit Data</Button>}
                {loading && <Alert severity='info' sx={{ my: 2 }}>Please be patient during data submission as file uploads can take some time to complete</Alert>}
            </Box>
        </>
    )
}

export default BulkFuelDelivery